export const totalCheckboxSelected = ({ value = {}, total, whiteListIds = null }) => {
  if (value.all) {
    return total;
  }

  if (value.include) {
    return (whiteListIds ? value.include.filter((id) => whiteListIds.includes(id)) : value.include).length;
  }

  if (value.exclude) {
    return total - (whiteListIds ? value.exclude.filter((id) => whiteListIds.includes(id)) : value.exclude).length;
  }

  return 0;
};

export const itemsSelected = ({ value = {}, items }) => {
  if (value.all) {
    return items;
  }

  if (value.include) {
    return items.filter(({ id }) => value.include.includes(id));
  }

  if (value.exclude) {
    return items.filter(({ id }) => !value.exclude.includes(id));
  }

  return [];
};
